import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';

@Injectable()
export class StudentContactInfoService {

  private _url = AppSettings.API_ENDPOINT;
  constructor(private http: HttpClient) {
  }

  getStudentContactDetailsForEditForm(studentId, AUTHTOKEN) {
    let params = {studentId: studentId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentcontactinfoedit',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  getClassStandardsByCategory(categoryId, AUTHTOKEN) {
    let params = {categoryId: categoryId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/getClassStandardsByCategoryV2',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  getClassSectionsByClassIdFun(classStandardId, AUTHTOKEN) {
    let params = {classStandardId: classStandardId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/getClassSectionsByClassIdFunV2',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  studentClassChangeValidation(newClassId,oldClassId, studentId, AUTHTOKEN) {
    let params = {newClassId: newClassId,oldClassId:oldClassId, studentId: studentId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentClassChangeValidation',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  //update student details
  updateStudentDetails(studentContactInfo, AUTHTOKEN) {
    let params = studentContactInfo;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/edit/studentcontactinfoedit',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  /* Single endpoint handles both upload and delete for father/mother/guardian
     photos — fatherFile/motherFile/guardianFile are each optional file uploads,
     deletePhotoType lists whichever of fatherImage/motherImage/guardianImage
     should instead be reset to the default image. */
  updateParentsPicture(studentId, files: { fatherFile?: File, motherFile?: File, guardianFile?: File }, deletePhotoType: string[], AUTHTOKEN) {
    const formData = new FormData();
    formData.append('studentId', studentId);
    formData.append('lang', 'en');
    if (files.fatherFile) {
      formData.append('fatherImage', files.fatherFile);
    }
    if (files.motherFile) {
      formData.append('motherImage', files.motherFile);
    }
    if (files.guardianFile) {
      formData.append('guardianImage', files.guardianFile);
    }
    (deletePhotoType || []).forEach(photoType => {
      formData.append('deletePhotoType', photoType);
    });
    const headers = new HttpHeaders().append('token', AUTHTOKEN);
    return this.http.post(AppSettings.API_ENDPOINT_V3 + '/class/student/update/parents/picture',
      formData, {headers: headers})
      .pipe(map(res => res));
  }
}
